import React from "react";
import { Link } from "react-router-dom";
import HomeCards from "../../Components/HomeCards/HomeCards";

const Main = () => {
  const mainCardsData = [
    {
      name: "Services >",
      image: "servicecard.png",
      background: "bg-gold2",
      to: "/services",
    },
    {
      name: "BOOK APPOINTMENT >",
      image: "appoincard.png",
      background: "bg-gold3",
      to: "/book",
    },
    {
      name: "MEMBERSHIPS >",
      image: "membershipcard.png",
      background: "bg-gold4",
      to: "/memberships",
    },
  ];
  return (
    <div>
      <section className="bg-imagehero bg-no-repeat bg-cover h-screen flex justify-center items-center w-full">
        <div className="w-[90%] sm:w-[780px] h-[248px]">
          <div className="bg-[#ffffffcc] h-[56px] w-full flex items-center py-1 pl-6 mb-2">
            <p className="font-font-Montserrat font-normal text-[18px] sm:text-[28px] sm:leading-[36.4px] text-[#000000]">
              Essential Service used by high performance individuals
            </p>
          </div>
          {/* <div className="bg-[#ffffffcc] h-[56px] w-[88%] flex items-center py-1 pl-6 mb-2">
            <p className="font-font-Montserrat font-normal text-[18px] sm:text-[28px] sm:leading-[36.4px] text-[#000000]">
              with back, neck and shoulder pain use
            </p>
          </div> */}
          <div className="bg-[#ffffffcc] h-[56px] w-[78%] flex items-center py-1 pl-6 mb-2">
            <p className="font-font-Montserrat font-normal text-[18px] sm:text-[28px] sm:leading-[36.4px] text-[#000000]">
              to maintain their competitive edge,{" "}
            </p>
          </div>
          <div className="bg-[#ffffffcc] h-[56px] w-[58%] flex items-center py-1 pl-6 mb-2">
            <p className="font-font-Montserrat font-normal text-[18px] sm:text-[28px] sm:leading-[36.4px] text-[#000000]">
              that will work for you
            </p>
          </div>
        </div>
      </section>
      <section className="">
        <div className="flex flex-col sm:flex-row items-center justify-center mt-[-136px]">
          {mainCardsData?.map(({ name, image, background, to }) => (
            <HomeCards
              name={name}
              image={image}
              background={background}
              to={to}
            />
          ))}
        </div>
      </section>
      <section className="h-[400px] sm:h-[350px] md:h-[312px] bg-[#262626] mt-[-48px] flex justify-center items-end">
        <div className="px-2 sm:px-4 md:px-6 lg:px-20 py-2 sm:py-2 md:py-4 lg:py-12">
          <h2 className="font-font-Montserrat font-semibold text-[32px] sm:text-[48px] leading-[62.4px] text-center text-[#faad14]">
            Welcome to SILC
          </h2>
          <p className="font-font-Titillium font-normal text-[18px] sm:text-[22px] leading-[33px] tracking-[0.0094em] text-[#FFFFFF]">
            Most entrepreneurs and high performance individuals lead busy lives
            with limited time for self, so we created a holistic treatment
            service that comes to you weekly, that’s individually tailored to
            your convenience and needs, which destress, reshapes, rejuvenate,
            and energises so that you can continue your high value work with
            confidence, and enjoy more quality time with self and love ones.{" "}
          </p>
        </div>
      </section>
      <section className="services">
        <h2 className="font-font-Montserrat font-semibold text-[32px] sm:text-[48px] leading-[62.4px] text-center text-[#faad14]">
          Our Services
        </h2>
        <div className="flex-center">
          <div className="service-card">
            <img
              src="./assets/Service1.png"
              className="service-card-image"
              alt="card1image"
            />
            <p className="typography">Acupuncture</p>
            <p className="typography1">
              One of our magic services that helps reduce your headaches, joint
              pain and muscular pain, and brings in stress relief which helps
              you relax, meaning you can have better sleep, reduced pain,
              increased mental focus and clarity.
            </p>
            <Link to="/services/b4b90267-68bc-4e39-8e6f-1ee8ebefe72e">
              <img
                src="./assets/arrow-right.png"
                className="service-card-arrow"
                alt="card1imagearrow"
              />
            </Link>
          </div>
          <div className="service-card">
            <img
              src="./assets/Service2.png"
              className="service-card-image"
              alt="card2image"
            />
            <p className="typography">Deep Tissue Massage</p>
            <p className="typography1">
              This magic touch service focuses on those deep tight muscles
              (knots) which will allow you to have less discomfort and throbbing
              pain and that means you can focus on those things that matters
              most to you.
            </p>
            <Link to="/services/a4528e8b-e27b-4a39-a5bd-b22e592eec1b">
              <img
                src="./assets/arrow-right.png"
                className="service-card-arrow"
                alt="card1imagearrow"
              />
            </Link>
          </div>
          <div className="service-card">
            <img
              src="./assets/Service3.png"
              className="service-card-image"
              alt="card3image"
            />
            <p className="typography">Physiotherapy</p>
            <p className="typography1">
              A magic touch service that restores strength, function and
              mobility, which will allow you to return to active participation,
              that means you can get back to enjoying all the things that matter
              to you .
            </p>
            <Link to="/services/9ea3d8cc-2461-4e0b-9218-7bf4bd6c447b">
              <img
                src="./assets/arrow-right.png"
                className="service-card-arrow"
                alt="card1imagearrow"
              />
            </Link>
          </div>
        </div>
        <Link to="/services">
          <p className="typography view-service">{`VIEW ALL SERVICES >`}</p>
        </Link>
      </section>
      <section className="client-saying">
        <h3 className="font-font-Montserrat font-normal text-[20px] sm:text-[34px] leading-[30px] sm:leading-[44px] tracking-[0.0156em] text-center text-[#3A3A3C]">
          I love what I do. Need inspiration?
        </h3>
        <p className="font-font-Montserrat font-medium text-[30px] sm:text-[60px] leading-[60px] sm:leading-[130px] tracking-[-0.0313em] text-center text-[#FAAD14]">
          Check out what our Clients are saying!
        </p>
        <div className="client-saying-card">
          <div className="play-image">
            <img src="./assets/play.png" alt="playimage" />
          </div>
          <h4>Lorem ipsum</h4>
          <p className="typography1">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Parturient
            arcu non felis eget vulputate tempor duis non. Aliquam viverra elit
            aliquam pulvinar purus. Est felis, at fringilla fermentum sit nibh
            ut arcu placerat.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Main;
